module.exports = __webpack_public_path__ + "static/media/picto-red-fast.1de4b1ae.png";